<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg3 class="login-box">
            <v-card class="pa-3" height="250px">
              <v-card-text>
                <v-form ref="isFormValid" class="pt-3" lazy-validation>
                  <v-text-field prepend-icon="mdi-email" :label="$t('message.user.email')" type="text" v-model="email" :rules="email ? $_emailValidation : $_requiredValidation"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-layout justify-center>
                  <v-btn color="primary" id="updatebtn" @click="updatePassword" :loading="loading">{{ $t('message.common.send') }}</v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      loading: false
    }
  },
  created () {
    this.$i18n.locale = 'no'
    this.$store.dispatch('logout')
  },
  methods: {
    updatePassword () {
      if (this.$refs.isFormValid.validate()) {
        this.loading = true
        this.$_executeApi('post', `users/forgot_password?email=${this.email}`)
          .then((response) => {
            if (response) {
              if (response) {
                this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.login.linkShared') })
                this.$router.push('/login')
              }
            }
          }).catch((error) => {
            if (error.response.status === 404) {
              this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.login.mailNotFound') })
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>

<style scoped>
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
  .login-box {
    box-shadow: 0px 0px 34px #036693;
  }
</style>
